export default __webpack_public_path__ + "static/media/student_note_icon.1c61cdd9.svg";